export default __webpack_public_path__ + "static/media/screen7.a3ee8e82.png";